import { JobSender } from '@/job-sender';
import Worker from './worker?worker';

export const jobSender = new JobSender(new Worker());
